import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/articles';

export default function LatestArticles() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新文章
            </h2>
            <p className="text-foreground-500 text-sm mt-1">保持对韩国伦理文化的最新洞察</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 cursor-pointer transition-all duration-300 hover:-translate-y-0.5"
            >
              <div className="h-48 relative overflow-hidden">
                <div
                  className="absolute inset-0 bg-cover bg-center group-hover:scale-105 transition-transform duration-500"
                  style={{ backgroundImage: `url('${article.imageUrl}')` }}
                ></div>
              </div>

              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="inline-block px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime} 分钟</span>
                </div>

                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>

                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>

                <div className="flex items-center justify-between pt-3 border-t border-background-200">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-user-line"></i> {article.author}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}